import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "@/components/Login";
import ResetPassword from "@/components/ResetPassword";
import Dashboard from "@/components/Dashboard";
import Products from "@/components/Products";
import Sales from "@/components/Sales";
import SalesHistory from "@/components/SalesHistory";
import Subscriptions from "@/components/Subscriptions";
import Clients from "@/components/Clients";
import Inventory from "@/components/Inventory";
import Expenses from "@/components/Expenses";
import Reports from "@/components/Reports";
import Users from "@/components/Users";
import Layout from "@/components/Layout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios defaults
axios.defaults.baseURL = API;

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    
    if (token && savedUser) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleLogin = (token, userData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setIsAuthenticated(false);
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            !isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/" />
          } />
          
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route path="/" element={
            isAuthenticated ? <Layout user={user} onLogout={handleLogout} /> : <Navigate to="/login" />
          }>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="sales" element={<Sales />} />
            <Route path="sales-history" element={
              user?.role === 'admin' ? <SalesHistory /> : <Navigate to="/" />
            } />
            <Route path="subscriptions" element={<Subscriptions />} />
            <Route path="clients" element={<Clients />} />
            <Route path="inventory" element={
              user?.role === 'admin' ? <Inventory /> : <Navigate to="/" />
            } />
            <Route path="expenses" element={<Expenses />} />
            <Route path="reports" element={<Reports />} />
            <Route path="users" element={
              user?.role === 'admin' ? <Users /> : <Navigate to="/" />
            } />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
